import Portfolio from "./Portfolio";
import Notepad from "./Notepad";
import RecycleBin from "./RecycleBin";
import MediaPlayer from "./MediaPlayer";
import VideoPlayer from "./VideoPlayer";
import Documents from "./Documents";
import AccessDenied from "./AccessDenied";
import Minesweeper from "./Minesweeper";

const ALL_BUTTONS = ["minimize", "maximize", "close"];

// defaultSize: where a window opens before the user has ever moved it; omitted for the portfolio,
// which starts in its centered CSS layout.
export const APPS = {
  portfolio: {
    id: "portfolio",
    title: "Aaron Zhu - Portfolio",
    icon: "/ie-window-icon.png",
    component: Portfolio,
    // The portfolio is the site itself, so it can be tucked away but never closed.
    buttons: ["minimize", "maximize"],
    // Without a desktop there is nowhere to switch between apps, so mobile only shows the portfolio.
    showOnMobile: true,
    // Opens maximized; restoring fits it to the open desktop between the icon columns.
    startMaximized: true,
    fitToDesktop: true,
    minSize: { w: 600, h: 600 },
  },
  notepad: {
    id: "notepad",
    title: "readme.txt - Notepad",
    icon: "/desktop-icons/notepad-icon.png",
    component: Notepad,
    buttons: ALL_BUTTONS,
    defaultSize: { w: 500, h: 480 },
    minSize: { w: 260, h: 180 },
  },
  recycleBin: {
    id: "recycleBin",
    title: "Recycle Bin",
    icon: "/desktop-icons/recycle-bin-icon.png",
    component: RecycleBin,
    buttons: ALL_BUTTONS,
    defaultSize: { w: 760, h: 400 },
    minSize: { w: 360, h: 200 },
  },
  mediaPlayer: {
    id: "mediaPlayer",
    title: "las palomitas.mp3 - Media Player",
    icon: "/desktop-icons/media-player-icon.png",
    component: MediaPlayer,
    buttons: ALL_BUTTONS,
    defaultSize: { w: 420, h: 170 },
    minSize: { w: 320, h: 150 },
  },
  videoPlayer: {
    id: "videoPlayer",
    title: "saylo.wmv - Media Player",
    icon: "/desktop-icons/media-player-icon.png",
    component: VideoPlayer,
    buttons: ALL_BUTTONS,
    defaultSize: { w: 640, h: 400 },
    minSize: { w: 320, h: 220 },
  },
  documents: {
    id: "documents",
    title: "Documents",
    icon: "/desktop-icons/documents-icon.png",
    component: Documents,
    buttons: ALL_BUTTONS,
    defaultSize: { w: 420, h: 260 },
    minSize: { w: 260, h: 180 },
  },
  myComputer: {
    id: "myComputer",
    title: "My Computer",
    icon: "/desktop-icons/my-computer-icon.png",
    component: AccessDenied,
    buttons: ["close"],
    // A message box: fixed size, like the real Win98 dialog.
    fixedSize: true,
    defaultSize: { w: 340, h: 160 },
    minSize: { w: 340, h: 160 },
  },
  minesweeper: {
    id: "minesweeper",
    title: "Minesweeper",
    icon: "/desktop-icons/minesweeper-icon.png",
    component: Minesweeper,
    buttons: ["minimize", "close"],
    fixedSize: true,
    defaultSize: { w: 260, h: 340 },
    minSize: { w: 260, h: 340 },
  },
};
